<template>
    <div>
        <HeaderBg :img="img" title="إضافة مدينة" />

        <div class="form_container">
            <form @submit.prevent="addCity">
                <div class="input_container">
                    <label> المدينة باللغه العربية</label>
                    <input type="text" v-model="city.translation[0].name">
                </div>
                <div class="input_container">
                    <label> المدينة باللغه الإنجليزية</label>
                    <input type="text" v-model="city.translation[1].name">
                </div>
                <div class="input_container">
                    <label>سعر التوصيل</label>
                    <input type="text" v-model="city.delivery_price">
                </div>
                <div class="alert alert-danger mt-2" role="alert" v-if="ErrorCheck == true">
                    <p v-for="(error, index) in errors" :key="index"> {{error}} </p>
                </div>
                <button class="saveBtn" v-if="postLoaded == false">
                    {{this.$route.params.id !== undefined ? ' تعديل' : 'حفظ +' }}
                </button>
                <button class="saveBtn" v-if="postLoaded == true"><b-spinner></b-spinner></button>
            </form>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import HeaderBg from '../../global/HeaderBg/HeaderBg';
import Request from '../../../services/Request';
import store from "@/store/index.js";
export default {
    name :'AddCity',
    components: {HeaderBg},
    data(){
        return{
            img: require('../../../assets/images/locationLarg.png'),
            postLoaded: false,
            city: {
                delivery_price : '',
                translation : [
                    {
                        name : "",
                        local : "ar"
                    },
                    {
                        name : "",
                        local : "en"
                    }
                ]
            },
            errors: [],
            ErrorCheck: false,
        }
    },
    mounted(){
        this.getCity();
    },
    methods:{
        addCity(){
            this.postLoaded = true;
            if(this.$route.params.id !== undefined){
                axios.put(`${store.state.domain}/admin/city/${this.$route.params.id}`, this.city, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                })
                .then( () => {
                    this.$router.push('/store-admin/cities')
                    this.postLoaded = false
                })  
                .catch(err =>  {
                    console.log(err.response.data.errors)
                    this.errors = err.response.data.errors;
                    this.ErrorCheck = true;
                    this.postLoaded = false;
                    
                })
            } else {
                axios.post('https://app.almujtama.com.sa/admin/city', this.city, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                })
                .then( () => {
                    this.$router.push('/store-admin/cities')
                    this.postLoaded = false
                })  
                .catch(err =>  {
                    this.errors = err.response.data.errors;
                    this.ErrorCheck = true;
                    this.postLoaded = false;
                })
            }
        },
        getCity(){
            if(this.$route.params.id !== undefined){
                console.log('test')
                Request.fetch(`admin/city/${this.$route.params.id}`)
                .then((response) => {
                    this.city.delivery_price = response.data.data.delivery_price
                    this.city.translation[0].name = response.data.data.translation[0].name
                    this.city.translation[1].name = response.data.data.translation[1].name
                })
                .catch(err => {
                    if(Request.statusIsFaield(err)){
                        this.$router.push('/login')
                        localStorage.removeItem('token')
                    }
                });
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.form_container{
    background-color: #FFF;
    border-radius: 10px;
    margin: 40px auto;
    padding: 70px 100px;
    width: 482px;
    @media (max-width: 576px) {
        width: 97%;
        padding: 30px;
    }
    form{
        > div{
            label{
                display: block;
                text-align: center;
                font-size: 16px;
                color: #717171;
                font-weight: 600;
                margin-bottom: 10px;
            }
            input{
                border: 1px solid #71717191;
                font-size: 16px;
                padding: 5px 10px;
                border-radius: 10px;
                display: block;
                margin: auto;
                width: 100%;
            }
        }
        button{
            margin: 30px auto 0 auto;   
        }
    }
}
</style>